const lines = [
  ['Every great story begins with a moment of curiosity.', 0.4, 4.2],
  ['You notice something small, and suddenly the whole world feels different.', 4.7, 9.5],
  ['That is where the good stuff starts.', 10.1, 12.8],
  ['Not with a perfect plan, but with a simple question.', 13.5, 17.4],
  ['What happens if we look a little closer?', 18.1, 21.3],
  ['So we follow the light, and see where it takes us.', 22.0, 26.2],
  ['Sometimes the best parts are the ones we never expected.', 27.0, 31.7],
  ['And that is a story worth telling.', 32.4, 35.2]
];

export const demoWords = lines.flatMap(([line, start, end], lineIndex) => {
  const tokens = line.split(' ');
  const step = (end - start) / tokens.length;
  return tokens.map((text, index) => ({
    id: `demo-${lineIndex}-${index}`,
    text,
    start: Number((start + index * step).toFixed(3)),
    end: Number((start + (index + 1) * step).toFixed(3)),
    line: lineIndex
  }));
});

export const demoProject = {
  title: 'The art of noticing',
  duration: 36,
  filename: 'original-footage.mov',
  width: 1920,
  height: 1080,
  fpsNum: 24000,
  fpsDen: 1001,
  audioChannels: 2,
  audioSampleRate: 48000,
  timecode: '00:00:00:00',
  frameStatus: 'demo-cfr',
  words: demoWords,
  cuts: [{ start: 10.1, end: 12.8 }],
  isDemo: true
};

export const exportTestProject = {
  title: 'CutScript XML relink test',
  duration: 10,
  filename: 'cutscript-test-source.mov',
  width: 1920,
  height: 1080,
  fpsNum: 25,
  fpsDen: 1,
  audioChannels: 2,
  audioSampleRate: 48000,
  timecode: '00:00:00:00',
  cuts: [{ start: 2, end: 4 }, { start: 7, end: 8 }]
};
